import { render, staticRenderFns } from "./ProductsParametersTab.vue?vue&type=template&id=6e39e287&"
import script from "./ProductsParametersTab.vue?vue&type=script&lang=js&"
export * from "./ProductsParametersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports